export const creditCardCvcFormateStrategy = (value: string) => {
  return !!value.match('^[0-9]{3}$');
};
